export function getPendingLegalTina(axiosPrivate: any, params: any) {
  const id = params.idLegal
  return axiosPrivate.get(`/legal-tina/review/${id}`)
}

export function submitLegalTina(axiosPrivate: any, idLegal: any, data: any) {
  return axiosPrivate.post(`/legal-tina/review/${idLegal}`, data)
}
